export const SEARCH_FORM_TEXTS = {
  searchBtn: 'Найти туры',
} as const;
